export default {"src":"/_next/static/media/KML.ec6e880f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};